/// <reference path="../../resources/resources.ts" />

namespace OfficeGuy.Inputs {
    export class CorporateNumberValidation {
        static ValidateElement(CorporateNumber: string, Element: any): boolean {
            var Valid = CorporateNumberValidation.IsValid(CorporateNumber);
            if (Valid)
                Element.removeClass("input-validation-warning");
            else
                Element.addClass("input-validation-warning");
            $(Element).closest(".sumit-field-value").toggleClass("sumit-field-value-warning", !Valid);
            return Valid;
        }
        static IsValid(CorporateNumber: string) {
            var Length = CorporateNumber.length;
            if (Length == 0)
                return true;
            else if (Length < 7 || Length > 9 || isNaN(Number(CorporateNumber)))
                return false;
            else if (CorporateNumber[0] == '5' || CorporateNumber[0] == '9')
                return CorporateNumber.length == 9;
            else {
                if (CorporateNumber.length < 9)
                    CorporateNumber = String("000000000" + CorporateNumber).slice(-9);

                var Sum = 0;
                for (var i = 0; i < CorporateNumber.length; i++) {
                    var Validity = Number(CorporateNumber[i]) * ((i % 2) + 1);
                    Sum += (Validity > 9) ? Validity - 9 : Validity;
                }
                return (Sum % 10) == 0;
            }
        }
    }
}

$(document).on("Teva.Init", function () {
    $.validator.addMethod("corporatenumber", OfficeGuy.Inputs.CorporateNumberValidation.ValidateElement);
});
